import { Disposable } from "@baseline/common/disposable";
import { useEffect, useMemo, useRef } from "react";


export function useController<T extends Disposable>(provider: () => T): T;
export function useController<T extends Disposable>(provider: () => T, dependencies: any[]): T;
export function useController<T>(provider: () => T): T;
export function useController<T>(provider: () => T, dependencies: any[]): T;
export function useController<T>(provider: () => T, dependencies?: any[]): T
{
    const controller = useRef<T>(undefined);

    controller.current = useMemo(
        () =>
        {
            if (Disposable.isDisposable(controller.current))
                controller.current.dispose();
            return provider();
        },
        dependencies ?? []
    );

    useEffect(
        () => () =>
        {
            if (Disposable.isDisposable(controller.current))
                controller.current.dispose();
        },
        []
    );

    return controller.current;
}
